<!-- ConfirmInput.svelte -->
<svelte:options accessors />

<script lang="ts">
	import TextInputSub from './TextInputSub.svelte';
	import { SetValidator, type TValidators } from '$lib/validator';

	export let Title: string = '';
	export let InsideTitle: string = '';
	export let Validator: string | null = null;
	export let Required: boolean = true;
	export let AutoComplete: string | null = null;
	export let Type: string = 'text';
	export let MaxLength: number = 100;
	export let ShowCount: boolean = true;
	export let ErrorMsg: string = Required ? 'Required field' : 'Invalid value';

	let inputValue: string = '';
	let confirmValue: string = '';
	let inputComp: TextInputSub;
	let confirmComp: TextInputSub;

	export let Valid: boolean = false;
	export let Value: string | null = null;

	let validator: TValidators | null = null;

	if (Validator) {
		validator = SetValidator(Validator, Required);
	}

	function onInputChange() {
		validate();
	}

	function onConfirmChange() {
		validate();
	}

	export function focus() {
		if (!inputValue) {
			inputComp.focus();
		} else if (!confirmValue) {
			confirmComp.focus();
		}
	}

	export async function validate() {
		let isInputValid = true;
		let isConfirmValid = true;

		// Validate main input
		if (validator) {
			isInputValid = await validator.Validate(inputValue);
		} else if (Required) {
			isInputValid = inputValue.trim() !== '';
		}

		// Validate confirmation input
		isConfirmValid = inputValue === confirmValue;

		Valid = isInputValid && isConfirmValid;

		// Update UI based on validation
		updateValidationState(inputComp, isInputValid, isInputValid ? '' : ErrorMsg);
		updateValidationState(
			confirmComp,
			isConfirmValid,
			isConfirmValid ? '' : `${InsideTitle} does not match`
		);

		// Set the value if valid
		if (Valid) {
			Value = inputValue;
		} else {
			Value = null;
		}

		return Valid;
	}

	function updateValidationState(comp: TextInputSub, isValid: boolean, message: string) {
		if (isValid) {
			comp.$set({ Valid: true });
			comp.inputEl.classList.add('is-valid');
			comp.inputEl.classList.remove('is-invalid');
		} else {
			comp.$set({ Valid: false, ErrorMsg: message });
			comp.inputEl.classList.add('is-invalid');
			comp.inputEl.classList.remove('is-valid');
		}
	}

	export function appendData(formData: FormData) {
		inputComp.appendData(formData);
	}
</script>

<div class="confirm-input">
	{#if Title}
		<div class="comp-title">{Title}</div>
	{/if}

	<!-- Original Input -->
	<TextInputSub
		bind:this={inputComp}
		bind:Value={inputValue}
		{Type}
		{Required}
		{MaxLength}
		Placeholder={InsideTitle}
		{AutoComplete}
		Name={InsideTitle}
		{ShowCount}
		on:input={onInputChange}
	/>

	<!-- Confirm Input -->
	<TextInputSub
		bind:this={confirmComp}
		bind:Value={confirmValue}
		{Type}
		{Required}
		{MaxLength}
		Placeholder={`Confirm ${InsideTitle}`}
		{AutoComplete}
		Name={`confirm_${InsideTitle}`}
		{ShowCount}
		on:input={onConfirmChange}
	/>

	<!-- Error Messages -->
	{#if !Valid && !inputComp.Valid}
		<div class="error-message">{inputComp.ErrorMsg}</div>
	{:else if !Valid && !confirmComp.Valid}
		<div class="error-message">{confirmComp.ErrorMsg}</div>
	{/if}
</div>
